import {
  DOWNLOAD_ANDROID_TEXT,
  DOWNLOAD_IOS_TEXT,
} from '@/constants/app.constants';
import { gtmAppDownloadClick } from '@/utils/events';

export const APP_LINKS = {
  appStore: 'https://apps.apple.com/au/app/exetel/id6474650965',
  playStore:
    'https://play.google.com/store/apps/details?id=com.exetel.app&hl=en_AU',
};

export const onClickIOS = () => {
  gtmAppDownloadClick({
    clickText: DOWNLOAD_IOS_TEXT,
    clickUrl: APP_LINKS.appStore,
    appType: 'iOS',
  });
};

export const onClickAndroid = () => {
  gtmAppDownloadClick({
    clickText: DOWNLOAD_ANDROID_TEXT,
    clickUrl: APP_LINKS.playStore,
    appType: 'Android',
  });
};
